import { Zap } from "lucide-react";

export function DagvestigationsEmpty() {
  return (
    <div className="flex flex-col items-center justify-center h-full p-8 text-center">
      <div className="max-w-md">
        <div className="mb-6 text-foreground opacity-80">
          <Zap size={28} strokeWidth={1.5} className="mx-auto mt-4" />
        </div>
        <h3 className="text-xl font-semibold text-foreground mb-3">No investigation run selected</h3>
        <p className="text-muted-foreground mb-4">
          Select an investigation run from the sidebar to view its details.
        </p>
        <div className="flex justify-center">
          <div className="w-16 h-1 bg-muted rounded-full opacity-50"></div>
        </div>
      </div>
    </div>
  );
}

export default DagvestigationsEmpty;